module.exports = __webpack_public_path__ + "media/1.c82231bc.mp3";